import React from 'react';
import { sendAnalytics } from '../../../analytics';
import RenderSectionParagraph from '../RenderSectionParagraph/RenderSectionParagraph';
import RenderSectionImages from '../RenderSectionImages/RenderSectionImages';
import ContentSectionDropdown from '../ContentSectionDropdown/ContentSectionDropdown';
import { ANALYTICS_EVENTS } from '../../../utils/constants';
import classes from './ContentSections.module.scss';

const ContentSections = (props) => {
    const { content_blocks, payment_page_type: payPageType } = props?.data || {};

    if (content_blocks?.length === 0) return null;

    const ContentBlock = ({ dataObject }) => {
        const { visible, title, subtitle, images, description, cta_config, dropdown } = dataObject;
        if (!visible) return null;

        let ctaButtonPostion = "";
        let ctaTarget = "_blank";
        let ctaClassName = "";
        if (cta_config?.position === "left") {
            ctaButtonPostion = classes.Left;
        } else if (cta_config?.position === "right") {
            ctaButtonPostion = classes.Right;
        }
        if (cta_config?.new_window === false) {
            ctaTarget = "_self";
        }
        if (cta_config?.type === "button") {
            ctaClassName = classes.Button;
        }

        const handleCTAClick = (e, ctaConfigUrl) => {
            if(ctaConfigUrl.includes('/r/auth')) {
                sendAnalytics({
                    vendor: ['mixpanel', 'ga'],
                    eventData: {
                        event: ANALYTICS_EVENTS.PP_REDIRECT_RCPT_PAGE,
                    }
                })
            }
            if(payPageType === 'STATIC-PAGE') {
                sendAnalytics({
                    vendor: ['mixpanel', 'ga'],
                    eventData: {
                        event: ANALYTICS_EVENTS.PP_STATIC_PAGE_REDIRECT,
                        trackingData: {
                            redirect_url: ctaConfigUrl
                        }
                    }
                })
            }
        }

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className={classes.ContentBlock}>
                        {title ? (<h1 className={classes.Title}>{title}</h1>) : null}
                        {subtitle ? (<p className={classes.Subtitle}>{subtitle}</p>) : null}
                        {images?.length !== 0 ? <RenderSectionImages data={images} /> : null}
                        {description?.length !== 0 ? <RenderSectionParagraph data={description} /> : null}
                        {(cta_config?.url) ? 
                            (<div className={`${classes.BlockAction} ${ctaButtonPostion}`}>
                                <a href={cta_config.url} 
                                    rel="noopener noreferrer nofollow" 
                                    target={ctaTarget} 
                                    className={ctaClassName}
                                    onClick={(event) => handleCTAClick(event, cta_config.url)}
                                >
                                    {cta_config?.label || "View Details"}
                                </a>
                            </div>) 
                        : null}
                    </div>
                </div>
                
                {dropdown && dropdown?.visible ? 
                    <div className="col-lg-6 mx-auto">
                        <div className={classes.DropdownBlock}>
                            <ContentSectionDropdown dropdownData={dropdown} />
                        </div>
                    </div>
                : null}
            </div>
        )
    }

    
    return (
        <div className={classes.ContentSections}>
            {content_blocks?.map((blockData, index) => (<ContentBlock key={`content-block-${index}`} dataObject={blockData} />))}
        </div>
    )
}

ContentSections.propTypes = {}

export default ContentSections;